import PropTypes from "prop-types";

import ReadMore from "components/ReadMore";
import { useScreen } from "hooks";

import { StyledContainer, Title, ContentReadMore, Description } from "./styles";
import LoadingHeader from "./components/LoadingHeader";

const PageHeader = ({ title, description, loading }) => {
  const { isMobile } = useScreen();

  if (loading) return <LoadingHeader />;

  return (
    <StyledContainer data-testid="page-header">
      <Title align="center" variant="h1">
        {title}
      </Title>
      {description && (
        <Description align="center" variant="large">
          {isMobile && (
            <ContentReadMore>
              <ReadMore>{description}</ReadMore>
            </ContentReadMore>
          )}
          {!isMobile && description}
        </Description>
      )}
    </StyledContainer>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node)]),
  loading: PropTypes.bool,
};

export default PageHeader;
